import { ExIcon, IconSize } from '@boomi/exosphere';
import classNames from 'classnames';
import { translations } from '../translations/translations';
import type { Connector } from '../types/types';
import { base64SvgToSrc } from '../utils/utils';
import type { Language } from '../types/translations';

const IconCircle = ({
    connector,
    adaptiveSize = false,
    addGridArea = false,
    language = 'en',
    showAuthBadge = false,
}: {
    connector: Pick<Connector, 'icon'> & Pick<Connector, 'displayName'>;
    adaptiveSize?: boolean;
    addGridArea?: boolean;
    language?: Language;
    showAuthBadge?: boolean;
}) => (
    <div
        className={classNames('icon-circle', {
            'adaptive-size': adaptiveSize,
            'add-grid-area': addGridArea,
        })}
    >
        <img
            className="icon"
            src={base64SvgToSrc(connector.icon)}
            alt={connector.displayName}
            title={connector.displayName}
        />
        {showAuthBadge && (
            <span className="auth-badge" title={translations[language].TASK_authenticated}>
                <ExIcon icon="Authenticated" size={IconSize.S} />
            </span>
        )}
    </div>
);

export default IconCircle;
